import { Stack, Typography } from '@mui/material';
import { VyDateField } from '../../../../../components/design/inputs';
import { createContractFormSelectors, getSelectorAttribute } from '@vy/app-selectors';

export const ContractDateSection: React.FC = () => {
  return (
    <Stack spacing={1}>
      <Typography sx={{ fontSize: '12px', color: '#1B3D5599', mb: 1 }}>
        Select a starting date for this contract
      </Typography>
      <div {...getSelectorAttribute(createContractFormSelectors.startDateInput)}>
        <VyDateField name="startDate" />
      </div>
    </Stack>
  );
};
